goog.provide('el8.appchart.letters.printOrFaxFtue');

goog.require('el8.appchart.mgr.thirdpane');
goog.require('el8.service.urls');
goog.require('el8.template.appchart.letters.ftue');
goog.require('el8.uiwidget.NewDialog');
goog.require('el8.util.consts');


/**
 * A dialog that asks the user whether they want to print a document
 * (as they originally requested) or learn how to use fax letters
 */
el8.appchart.letters.printOrFaxFtue = (function() {

    var spec;
    var FTUE_KEY = 'FaxLetter';

    var that = new el8.uiwidget.NewDialog({
        contentFn: el8.template.appchart.letters.ftue.dialog,
        width: 350,
        autoHeight: true,
        position: 'center'
    });

    var super_init = that._init;
    that._init = function() {
        super_init.call(that);
        that.getDialogContainer().addClass('el8FTUEIntroDialog');

        that.getContentElt().on('click', '.fax-ftue-trigger',  function() {
            $.el8_ajax({
                type: 'POST',
                url: el8.service.urls.get('ftue', [el8.data.currUser.getId(),FTUE_KEY]),
            });
            el8.appchart.mgr.thirdpane.attachToLetter({
                type: el8.util.consts.CONSULTANT_LETTER,
                attachmentId: spec.attachmentId,
                showFtue: true
            });
            that.hide();

        }).on('click', '.print-trigger',  function() {
            if (spec.printFn) {
                spec.printFn();
            } else {
                var url = spec.url || el8.service.urls.get(spec.urlKey);
                window.open(url);
            }
            that.hide();

        });
    };

    var super_show = that.show;
    that.show = function(_spec) {
        super_show.call(that);
        spec = _spec;
    };

    var super_hide = that.hide;
    that.hide = function() {
        super_hide.call(that);
        spec = null;
    };

    return that;

})();